import { useTranslation } from "@opendash/i18n";
import { Button, ButtonProps } from "antd";
import { useWatch } from "antd/es/form/Form";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {} & ButtonProps;

export const SubmitButton = observer((props: Props) => {
  const t = useTranslation();
  const id = useWatch("existingTicketId");
  const isEditMode = !!id;
  const label = isEditMode
    ? t("maintenance:global.button.save_label")
    : t("maintenance:global.button.create.title");

  return (
    <Button htmlType="submit" type="primary" {...props}>
      {label}
    </Button>
  );
});
